const container = document.querySelector('[data-section-id]');
const sectionId = container?.dataset.sectionId;
const form = document.getElementById('omt-facets-form');
const grid = document.querySelector('[data-omt-grid]');
const activeFilters = document.getElementById('omt-active-filters');
const resultsCount = document.querySelector('[data-omt-results-count]');
const sortSelect = document.querySelector('select[name="sort_by"]');

async function applyFilters(url) {
  if (!container || !sectionId) return;
  const doc = await window.OMT.fetchSection(url, sectionId);
  const freshGrid = doc.querySelector('[data-omt-grid]');
  const freshActive = doc.querySelector('#omt-active-filters');
  const freshCount = doc.querySelector('[data-omt-results-count]');
  const freshFacetsForm = doc.getElementById('omt-facets-form');

  if (freshGrid && grid) grid.innerHTML = freshGrid.innerHTML;
  if (freshFacetsForm && form) form.innerHTML = freshFacetsForm.innerHTML;
  if (resultsCount) resultsCount.textContent = freshCount ? freshCount.textContent : '';
  if (freshCount) window.omtAnnounce?.(freshCount.textContent.trim());
  const existingActive = document.getElementById('omt-active-filters');
  if (freshActive) {
    if (existingActive) existingActive.replaceWith(freshActive);
    else activeFilters?.replaceWith(freshActive);
  } else if (existingActive) {
    existingActive.remove();
  }

  bindDynamicEvents();
  const cleanUrl = new URL(url, window.location.origin);
  cleanUrl.searchParams.delete('section_id');
  window.history.pushState({}, '', cleanUrl);
}

function buildUrlFromForm() {
  const params = new URLSearchParams(new FormData(form));
  if (sortSelect) params.set('sort_by', sortSelect.value);
  return `${window.location.pathname}?${params.toString()}`;
}

function bindDynamicEvents() {
  document.querySelectorAll('[data-omt-load-more]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      event.preventDefault();
      if (!sectionId) return;
      const doc = await window.OMT.fetchSection(link.dataset.nextUrl, sectionId);
      const freshGrid = doc.querySelector('[data-omt-grid]');
      const pagination = grid?.querySelector('[data-omt-pagination]');
      if (freshGrid && pagination) {
        const cards = Array.from(freshGrid.children).filter((node) => node !== freshGrid.querySelector('[data-omt-pagination]'));
        cards.forEach((card) => {
          if (!card.matches('[data-omt-pagination]')) pagination.before(card);
        });
        const freshPagination = freshGrid.querySelector('[data-omt-pagination]');
        if (freshPagination) pagination.replaceWith(freshPagination);
      }
      bindDynamicEvents();
    });
  });
}

form?.addEventListener('change', (event) => {
  if (event.target.matches('input[type="checkbox"]')) applyFilters(buildUrlFromForm());
});
form?.addEventListener('submit', (event) => {
  event.preventDefault();
  applyFilters(buildUrlFromForm());
});
sortSelect?.addEventListener('change', () => applyFilters(buildUrlFromForm()));

let priceDebounce;
form?.addEventListener('input', (event) => {
  if (!event.target.matches('input[type="number"]')) return;
  clearTimeout(priceDebounce);
  priceDebounce = setTimeout(() => applyFilters(buildUrlFromForm()), 500);
});

document.querySelector('[data-omt-filters-toggle]')?.addEventListener('click', () => {
  document.getElementById('omt-facets')?.classList.toggle('on');
});

bindDynamicEvents();
